/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Form } from '../models/form';
import { FormFilter } from '../models/form-filter';
import { Filing } from '../models/filing';
import { MultiDiscard } from '../models/multi-discard';
import { TbdFiling } from '../models/tbd-filing';
import { FilingByUser } from '../models/filing-by-user';
@Injectable({
  providedIn: 'root',
})
class FilingService extends __BaseService {
  static readonly getFilingsPath = '/filings';
  static readonly getFilingByFilingIdPath = '/filings/find-by-filing-id';
  static readonly getFilingByBackupIdPath = '/filings/find-by-backup-id';
  static readonly saveFilingPath = '/filings/save';
  static readonly unlockFilingPath = '/filings/unlock';
  static readonly lockFilingPath = '/filings/lock';
  static readonly discardFilingPath = '/filings/discard';
  static readonly multiDiscardFilingPath = '/filings/multi-discard';
  static readonly tbdFilingPath = '/filings/tbd';
  static readonly revertDiscardFilingPath = '/filings/discard/revert';
  static readonly getUserListPath = '/filings/userList';
  static readonly getLastFilingByUserPath = '/filings/lastUserFiling';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param filingFilter undefined
   * @return get All files.
   */
  getFilingsResponse(filingFilter: FormFilter): __Observable<__StrictHttpResponse<Array<Form>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = filingFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/filings`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Form>>;
      })
    );
  }
  /**
   * @param filingFilter undefined
   * @return get All files.
   */
  getFilings(filingFilter: FormFilter): __Observable<Array<Form>> {
    return this.getFilingsResponse(filingFilter).pipe(
      __map(_r => _r.body as Array<Form>)
    );
  }

  /**
   * @param filingId undefined
   * @return get file according to filing id.
   */
  getFilingByFilingIdResponse(filingId: number): __Observable<__StrictHttpResponse<Filing>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (filingId != null) __params = __params.set('filingId', filingId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/filings/find-by-filing-id`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Filing>;
      })
    );
  }
  /**
   * @param filingId undefined
   * @return get file according to filing id.
   */
  getFilingByFilingId(filingId: number): __Observable<Filing> {
    return this.getFilingByFilingIdResponse(filingId).pipe(
      __map(_r => _r.body as Filing)
    );
  }

  /**
   * @param backupId undefined
   * @return get file according to backup id.
   */
  getFilingByBackupIdResponse(backupId: number): __Observable<__StrictHttpResponse<Filing>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (backupId != null) __params = __params.set('backupId', backupId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/filings/find-by-backup-id`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Filing>;
      })
    );
  }
  /**
   * @param backupId undefined
   * @return get file according to backup id.
   */
  getFilingByBackupId(backupId: number): __Observable<Filing> {
    return this.getFilingByBackupIdResponse(backupId).pipe(
      __map(_r => _r.body as Filing)
    );
  }

  /**
   * @param filing undefined
   * @return it will return boolean weather file is saved or not
   */
  saveFilingResponse(filing: Filing): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = filing;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/filings/save`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param filing undefined
   * @return it will return boolean weather file is saved or not
   */
  saveFiling(filing: Filing): __Observable<boolean> {
    return this.saveFilingResponse(filing).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param filingId undefined
   * @return it will return boolean weather file is unlocked or not
   */
  unlockFilingResponse(filingId: number): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (filingId != null) __params = __params.set('filingId', filingId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/filings/unlock`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param filingId undefined
   * @return it will return boolean weather file is unlocked or not
   */
  unlockFiling(filingId: number): __Observable<boolean> {
    return this.unlockFilingResponse(filingId).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param params The `FilingService.LockFilingParams` containing the following parameters:
   *
   * - `filingId`:
   *
   * - `isForceLock`:
   *
   * @return it will return boolean weather file is locked or not
   */
  lockFilingResponse(params: FilingService.LockFilingParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.filingId != null) __params = __params.set('filingId', params.filingId.toString());
    if (params.isForceLock != null) __params = __params.set('isForceLock', params.isForceLock.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/filings/lock`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `FilingService.LockFilingParams` containing the following parameters:
   *
   * - `filingId`:
   *
   * - `isForceLock`:
   *
   * @return it will return boolean weather file is locked or not
   */
  lockFiling(params: FilingService.LockFilingParams): __Observable<boolean> {
    return this.lockFilingResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param params The `FilingService.DiscardFilingParams` containing the following parameters:
   *
   * - `reason`:
   *
   * - `filingId`:
   *
   * @return it will return boolean weather file is discarded or not
   */
  discardFilingResponse(params: FilingService.DiscardFilingParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reason != null) __params = __params.set('reason', params.reason.toString());
    if (params.filingId != null) __params = __params.set('filingId', params.filingId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/filings/discard`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `FilingService.DiscardFilingParams` containing the following parameters:
   *
   * - `reason`:
   *
   * - `filingId`:
   *
   * @return it will return boolean weather file is discarded or not
   */
  discardFiling(params: FilingService.DiscardFilingParams): __Observable<boolean> {
    return this.discardFilingResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param multiDiscard undefined
   * @return it will return boolean weather filings are discarded or not
   */
  multiDiscardFilingResponse(multiDiscard?: MultiDiscard): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = multiDiscard;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/filings/multi-discard`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param multiDiscard undefined
   * @return it will return boolean weather filings are discarded or not
   */
  multiDiscardFiling(multiDiscard?: MultiDiscard): __Observable<boolean> {
    return this.multiDiscardFilingResponse(multiDiscard).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param tbdFiling undefined
   * @return it will return boolean weather file is tbd or not
   */
  tbdFilingResponse(tbdFiling: TbdFiling): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = tbdFiling;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/filings/tbd`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param tbdFiling undefined
   * @return it will return boolean weather file is tbd or not
   */
  tbdFiling(tbdFiling: TbdFiling): __Observable<boolean> {
    return this.tbdFilingResponse(tbdFiling).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param params The `FilingService.RevertDiscardFilingParams` containing the following parameters:
   *
   * - `reason`:
   *
   * - `filingId`:
   *
   * @return it will return boolean weather file is discarded or not
   */
  revertDiscardFilingResponse(params: FilingService.RevertDiscardFilingParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reason != null) __params = __params.set('reason', params.reason.toString());
    if (params.filingId != null) __params = __params.set('filingId', params.filingId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/filings/discard/revert`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `FilingService.RevertDiscardFilingParams` containing the following parameters:
   *
   * - `reason`:
   *
   * - `filingId`:
   *
   * @return it will return boolean weather file is discarded or not
   */
  revertDiscardFiling(params: FilingService.RevertDiscardFilingParams): __Observable<boolean> {
    return this.revertDiscardFilingResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @return get user list that processed files.
   */
  getUserListResponse(): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/filings/userList`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      })
    );
  }
  /**
   * @return get user list that processed files.
   */
  getUserList(): __Observable<Array<string>> {
    return this.getUserListResponse().pipe(
      __map(_r => _r.body as Array<string>)
    );
  }

  /**
   * @param userName undefined
   * @return get user list that processed files.
   */
  getLastFilingByUserResponse(userName: string): __Observable<__StrictHttpResponse<FilingByUser>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (userName != null) __params = __params.set('userName', userName.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/filings/lastUserFiling`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FilingByUser>;
      })
    );
  }
  /**
   * @param userName undefined
   * @return get user list that processed files.
   */
  getLastFilingByUser(userName: string): __Observable<FilingByUser> {
    return this.getLastFilingByUserResponse(userName).pipe(
      __map(_r => _r.body as FilingByUser)
    );
  }
}

module FilingService {

  /**
   * Parameters for lockFiling
   */
  export interface LockFilingParams {
    filingId: number;
    isForceLock?: boolean;
  }

  /**
   * Parameters for discardFiling
   */
  export interface DiscardFilingParams {
    reason: string;
    filingId: number;
  }

  /**
   * Parameters for revertDiscardFiling
   */
  export interface RevertDiscardFilingParams {
    reason: string;
    filingId: number;
  }
}

export { FilingService }
